<template>
<v-app>
<v-sheet
    class="overflow-hidden"
  >
      <v-layout align-start
      >
        <v-flex>
          <v-btn class="mx-2" fab dark color="teal" @click.stop="drawer=!drawer">
              <v-icon dark>list</v-icon>
          </v-btn>
        </v-flex>
        <v-layout column justify-end>
          <v-flex>
            <p class="title right-text">{{current_mondai}}/50問(正解数:{{seitousuu}})</p>
          </v-flex>
        </v-layout>
      </v-layout>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      height="50%"
    >
      <v-subheader>{{subheader}}</v-subheader>
      <v-layout class="red--text">
          <v-subheader>{{current_mondai}}/{{mondaisu}}問</v-subheader>
      </v-layout>
      <v-list shaped>
        <v-list-item-group  color="#EF5350" >
            <v-list-item v-for="n of mondaisu" :key="n">
              <v-list-item-content>
                <div @click="mondai_change" :value="n">
                  <v-list-item-title v-text="n"></v-list-item-title>
                    <span v-if="seigo_list[0][n] == true" class="green--text">正解<v-icon color="green">mdi-circle-double</v-icon></span>
                    <span v-else-if="seigo_list[0][n] == false " class="red--text">不正解<v-icon color="red">mdi-close-outline</v-icon></span>
                </div>
              </v-list-item-content>
            </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider></v-divider>
    </v-navigation-drawer>
    <!-- 問題 -->
        <v-layout>
            <v-flex xs12 id="mondai">
              <div id="app">
                <mavon-editor
                 v-model="mondai"  
                 :subfield = "false"
                 :defaultOpen = "'preview'"
                 :toolbarsFlag = "false"
                 :editable="false"
                 :scrollStyle="true"
                 :ishljs = "true"
                 :boxShadow="false"
                 class="mavon"
                  />
              </div>
            </v-flex>
        </v-layout>
        <v-layout class="sentaku" >
          <v-flex xs12 sm6>
            <v-checkbox v-model="selected" label="A" value="A" multiple color="red"></v-checkbox>
            <v-checkbox v-model="selected" label="B" value="B" multiple color="primary"></v-checkbox>
            <v-checkbox v-model="selected" label="C" value="C" multiple color="success"></v-checkbox>
            <v-checkbox v-model="selected" label="D" value="D" multiple color="warning"></v-checkbox>
            <v-checkbox v-if="eIs" v-model="selected" label="E" value="E" multiple color="indigo"></v-checkbox>
          </v-flex>
          <v-flex xs12 sm6>
            <v-alert
              color="blue-grey"
              dark
              dense
              icon="mdi-school"
              prominent
            >
            <span>{{whichSelect}}</span>
            </v-alert>
          </v-flex>
        </v-layout>
        <v-layout justify-center align-center column>
          <v-flex xs12  >
            <v-btn large :color="btnColor" @click="kaitouShow">{{btnMes}}</v-btn>
          </v-flex>
        </v-layout>
        <transition>
        <v-layout v-if="kaitou_flg">
          <v-divider></v-divider>
          <v-flex xs12>
                <v-layout class="mt-3">
                  <v-card width="100%" color="#e6f6fa" >
                      <v-layout >
                        <v-card-title color="primary" class="title">
                           <v-alert width="100%" :color="alert_color" colored-border border="left"><v-icon>{{icon}}</v-icon><span class="title">{{alert_mes}}</span></v-alert>
                           <h3><v-icon color="orange">done_outline</v-icon>正答:{{kaitou.toString()}}</h3>
                        </v-card-title>
                      </v-layout>
                      <v-layout>
                        <v-card-title color="primary" class="title">
                           <h3><v-icon color="orange">question_answer</v-icon>【解説】</h3>
                        </v-card-title>
                      </v-layout>
                      <v-layout>
                        <v-card-text class="black--text">
                          <p id="target" v-html="kaisetu"></p>
                        </v-card-text>
                      </v-layout>
                      <v-layout>
                        <v-flex xs12>
                        <v-card-actions>
                            <v-flex xs5>
                              <v-btn outlined color="orange" block class="white--text" @click="preMondai">前の問題</v-btn>
                            </v-flex>
                            <v-flex xs2></v-flex>
                            <v-flex xs5>
                              <v-btn outlined color="orange" block class="white--text" @click="nextMondai">次の問題</v-btn>
                          </v-flex>
                        </v-card-actions>
                        </v-flex>
                      </v-layout>
                  </v-card>
                </v-layout>
                <v-layout color="primary">
                </v-layout>
          </v-flex>
        </v-layout>
        </transition>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
</v-sheet>
</v-app>
</template>

<script>
import firebase from 'firebase'
import {mavonEditor} from 'mavon-editor'


export default{
    data:() =>({
        subheader:'Silver1',
        mondaisu:50,
        //firebaseから取得
        mondai:"",
        kaitou:"",
        kaisetu:"",
        current_mondai:null,
        drawer:null,//画面左の
        exam_count:1,//現段階では試験は一つだけなので変更しない
        selected:[],//ユーザーが選択した回答を格納する
        eIs:true,
        kaitou_flg:false,
        btnMes:"回答する",
        btnColor:"success",
        alert_mes:"",
        alert_color:"",
        icon:"",
        //読み込み中のオーバーレイ
        overlay:false,
        //問題の正誤格納用の配列
        seigo_list:[
          { 1:null,2:null,3:null,4:null,5:null,6:null,7:null,8:null,9:null,10:null,
            11:null,12:null,13:null,14:null,15:null,16:null,17:null,18:null,19:null,20:null,
            21:null,22:null,23:null,24:null,25:null,26:null,27:null,28:null,29:null,30:null,
            31:null,32:null,33:null,34:null,35:null,36:null,37:null,38:null,39:null,40:null,
            41:null,42:null,43:null,44:null,45:null,46:null,47:null,48:null,49:null,50:null
          }
        ],
        seitousuu:0
    }),
    methods:{
        mondai_change:function(e){
            this.overlay = true
            this.kaitou_flg=false
            this.current_mondai =  e.currentTarget.getAttribute("value");
            this.mondai_get()
        },
        preMondai:function(){
          if (this.current_mondai != "1"){
            this.overlay = true
            this.kaitou_flg = false
            this.current_mondai = Number(this.current_mondai) - 1
            this.btnMes = "回答する"
            this.btnColor = "success"
            this.mondai_get()
          }
        },
        nextMondai:function(){
          if (this.current_mondai != "50"){
            this.overlay = true
            this.kaitou_flg = false
            this.current_mondai = Number(this.current_mondai) + 1
            this.btnMes = "回答する"
            this.btnColor = "success"
            this.mondai_get()
          }
        },
        kaitouShow:function(){
          //未選択ならエラーメッセージ
          if (!this.selected){
            alert('回答を未選択です')
            return
          }
          //正解・不正解を判定し、alert-messageを変更する
          if (this.kaitou.sort().toString() == this.selected.sort().toString()){
            this.alert_mes = "正解"
            this.alert_color = "success"
            this.icon="panorama_fish_eye"
            this.seigo_list[0][this.current_mondai] = true
          }else{
            this.alert_mes = "不正解"
            this.alert_color = "error"
            this.icon = "clear"
            this.seigo_list[0][this.current_mondai] = false
          }
          var user_kaitou = this.selected
          var mondai_kaitou = this.kaitou

          //回答済みなら回答・解説を表示
          this.kaitou_flg = !this.kaitou_flg
          this.btnMes = "回答済み"
          this.btnColor = "info"
          this.$nextTick(() => {
              scrollBy(0, 400);
          });
          //正答数をカウント(一回正答数を初期化)
          this.seitousuu = 0;
          for (var i=1; i <= this.mondaisu;i++){
            if (this.seigo_list[0][i] == true){
              this.seitousuu++;
            }
          }
        },
        mondai_get:function(){
          //データ初期化
          this.selected = []
          this.eIs = true
          //回答フラグについては、current_mondai変更時すぐfalseに
          // this.kaitou_flg=false
          this.btnMes = "回答する"
          this.btnColor = "success"
          var vue = this;
          if (window.location.hash == "#/gold-exam1"){
            var siken_syubetu = "gold"
          } else{
            var siken_syubetu = "silver"
          }
          //firebaseからデータ取得
          var res = window.location.hash
          var display_mondai = "mondai" + this.current_mondai
          firebase.database().ref('exam').on('value', function(snapshot) {
            vue.mondai = snapshot.val()[siken_syubetu]["exam1"][display_mondai].mondai
            vue.multi_sentaku = snapshot.val()[siken_syubetu]["exam1"][display_mondai].multi
            //答えは一つでも配列で渡される
            vue.kaitou = snapshot.val()[siken_syubetu]["exam1"][display_mondai].kotae
            vue.kaisetu = snapshot.val()[siken_syubetu]["exam1"][display_mondai].kaisetu
            if (snapshot.val()[siken_syubetu]["exam1"][display_mondai].max_sentakusi == "E"){
              vue.eIs = true
            }else{
              vue.eIs = false
            }
          });
          scrollTo(0, 0);
        }
    },
    created: function(){
      if (!this.current_mondai){
        this.current_mondai = 1
      }
      this.mondai_get()
    },
    watch: {
      overlay (val) {
        val && setTimeout(() => {
          this.overlay = false
        }, 1000)
      },
    },
    components:{
      mavonEditor
    },
    computed: {
      whichSelect () {
        if (this.selected == "" || this.selected == null){
          return "未選択"
        }else{
          return 'あなたの選択：' + this.selected.sort()
        }
      }
    },
}
</script>

<style>

.right-text{
  text-align: right;
}

.v-enter-active,
        .v-leave-active {
            transition: opacity 3s ease-out;
        }

.markdown-body {
    max-height: 600px;
    height: auto;
}

.v-application code {
    background-color: #f5f5f5;
    color: #bd4147;
    -webkit-box-shadow: none;
    box-shadow: none;
}

#app .v-note-wrapper {
    position: relative;
    min-width: 300px;
    min-height: 300px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-transition: all 0.3s linear 0s;
    transition: all 0.3s linear 0s;
    background: #fff;
    z-index: 0;
    text-align: left;
    white-space: pre-wrap;
    word-wrap:break-word
}

#app >>>code{
  box-shadow: none;
}

#app >>>.v-note-wrapper .v-note-panel {
    position: relative;
    border: none;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
}

.markdown-body >>> h1{
  font-size:26px;
}

.markdown-body >>> h2{
  font-size:24px;
}
.markdown-body >>> h3{
  font-size:22px;
}
.markdown-body >>> h4{
  font-size:20px;
}

.markdown-body >>> p{
  font-size:18px;
}
.markdown-body >>> code{
  font-size:16px;
}

</style>